var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsVip = function SvgDlsVip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3v18l8-4.55L20 21V3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17 8.632l-3.443-.518L12 5l-1.557 3.114L7 8.632l2.482 2.443-.571 3.436L12 12.907l3.09 1.604-.572-3.436z"
  })));
};

export default __webpack_public_path__ + "static/media/DLS_VIP.90671d0e.svg";
export { SvgDlsVip as ReactComponent };